
































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { vxm } from '@/store'

@Component({
  components: {},
})
export default class Agent extends Vue {
  private isLoading = true
  private agent = null
  private lastActiveTime = null
  private tab = 'agent'
  private diagnostics = null

  public created(): void {
    this.load()
  }

  private get agentId() {
    return this.$route.params.id
  }

  private load() {
    this.isLoading = true
    this.agent = null
    this.$axios
      .get('/v4/site/payment/cash-registers/setup/agents/' + this.agentId)
      .then((response) => {
        this.isLoading = false
        this.agent = response.data.data.agent
        this.lastActiveTime = response.data.data.lastActiveTime
        console.log('loaded')
      })
      .catch((err) => {
        vxm.alert.onAxiosError(err, 'Error fetching agent')
        this.isLoading = false
      })
  }

  private save() {
    alert('todo')
  }

  private connect() {
    alert('todo')
  }

  private disconnect() {
    alert('todo')
  }

  private runDiagnostics() {
    this.diagnostics = null
    this.isLoading = true
    this.$axios
      .post('/v4/site/payment/cash-registers/setup/agents/' + this.agentId + '/diagnostics')
      .then((response) => {
        this.isLoading = false
        this.diagnostics = response.data.data
      })
      .catch((err) => {
        vxm.alert.onAxiosError(err, 'Error fetching diagnostics')
        this.isLoading = false
      })
  }
}
